import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledFailIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 40,
			cy: 40,
			r: 30,
			fill: "#D41F24",
			stroke: "#D41F24",
			strokeWidth: 7.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.5713 49.4282L49.4275 30.572",
			stroke: "white",
			strokeWidth: 7.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.4284 49.428L30.5723 30.5718",
			stroke: "white",
			strokeWidth: 7.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledFailIcon);
const Memo = memo(ForwardRef);
export default Memo;
